/**
 * Page Layout Component
 * Wrapper component with AppBar and Footer for consistent page structure
 */

import React from 'react';
import { Box } from '@mui/material';
import MainAppBar from './MainAppBar';
import Footer from './Footer';

interface PageLayoutProps {
  children: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <MainAppBar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
};

export default PageLayout;
